export class MaintenanceCondition {
  name = '';
  in_maintenance = false;
  schedule_start_date = '';
  schedule_end_date = '';
}
